import { formatBusinessCountryCode } from '../components/BusinessDetails';

import { addErrorToDatadog } from './datadogError';

const baseAutocompleteRequest = {
  componentRestrictions: { country: ['us', 'ca'] },
  types: ['establishment'],
};

export const googleAutocomplete = async (text, searchType) =>
  new Promise((resolve, reject) => {
    if (!window?.google?.maps) reject('no google maps');
    const request = {
      ...baseAutocompleteRequest,
      input: text,
      types: [searchType],
    };

    try {
      new window.google.maps.places.AutocompleteService().getPlacePredictions(
        request,
        resolve
      );
    } catch (error) {
      reject(error);
    }
  });

export const formatGooglePlacesResult = (result) => {
  if (result) {
    return {
      businessAddress: result.structured_formatting.secondary_text,
      googleBusinessName: result.structured_formatting.main_text,
      placeId: result.place_id,
    };
  }
};

export const POWERED_BY_GOOGLE_SRC =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAAASCAYAAAC0PldrAAAIHElEQVR4Ae3ZBXDbWB7H8efglpmZGW0HlhzJDpSZmZkZ3W3s2DpmZmbmKx0zM/NdoGhotxTf9x9LHY027paW85v5bBRQopn32weqasqzk5Jw7BE9nHijHo5/Rw/HfqaHYl/keldZ8GJ7qBeqZ/6PNGlPUT5DeVKNqkyc18PJ6VDPtfEfnvUJz0dmpbwfmzMW6k5YFy96pBRTkCnL4MUDiy94oS0F+ZVZlD/5qxLLfNFkz0D0fBtfKOkpCcffrFfG6vVQ4hDUc6ypQLdDFmMdMiWIcjywaOHEB8zynPEFa1pCOWnHLw2Bej5oKtDzqEC+cGyoWZ5YaTDeGer57r4LRPLRCi40liy0QR4eVB5CG2QhU3KQneG+TM/qQhvk424L1Bwt73P22d9QoFD8bVB3KxVUWTX+gqW1mvvLtbr7Z7V+z6frNM/UlFIuKAD83I2v5y69eiL3y9dPZP/s2tdyPn39ZN7UVEq5oCz8x+WvjC/SQrEv8/u/z/O9siSUKNfC8agWSbrRaIH+p3lH1Pg976jxe38gz8JzzLM/g2QhpmIuIjCwB/0cg6HjGAxEsQQtIZmCtbBnLbY4BngZptkGaQmiMHAUhbCyEJMxCxGsh6QFltruOwIv7BmEfTAQwWwsvYMCTcMqGKat6AJJCXYjD1ZcWIdZsEdK8K50gZLroez4+l4G8j1PURlfAJWaMye7Vvd+otbvTVVr7hvVmvc/ci0YyNdAidTHVPa1EzmfuH4iN0WBbnD9H7lu8PXc10CJYDCVxanvffI8nAZvloQTNenZMXYt/YyJ5Y3tgar9nkCt5n2y4Tl073+5TprPEIYSknW2ARpkWosQOkFSiijK0BtuHME2ZGMMDLSDpBMMU29bYaIYBxfW4wBGojcmw8BIWM8Vwjq40QMubMR+231TYGAYJN1QhVUYgEHYgMgdFCiCBeiLYdiJI2iO9og6St4XBgZnKpAWjm2AsmNZO+E8jdlnqzrdvS49aO4fndWLekDVlbmHMoB/MQewAorCrDML86P6E816QD35lbyhzER/SZcouwJKq0oskd9PSX9aVnm5F1RJVbKQr13IVKCU251b7Xf/WwpcqxfMkVnngm9MW+sZ6gJeD24N1BHkwUouDmI28hDGBNjTDwZGIR9hFEOiYyu2YRIkY1GFhzAABvrCnpVYbyvQAeTAyiBHKa2sNUnmY5/jvnwcvYMCbXDMmG1QBR2SJdhu+5l52NXYMsqA7EsXI/5OKBvEhnMKK7LwtePpgYy9HIpB+lbDIGmFbihLTcAzs6FAuueDUJTkW0hdO5XrhrJc/1reTPk6BfsgZMY7iZS/KumFsmihxIFMBaoNeHxmiT/6H5+7Y41esJcl7K/pmdD9N64n4tZALYQzs7EDvTMMmgtBW7GWYyUk26DDj/1wYYHt+z7bUhixMXDMVqDFznG5zX1HIdmDGbDnTvdAGpzZhGWO/2n6ojnCKIIzDNClwQ1LRmU8ETCS3aEysU5r7FHmQckAyUD9sWJgPpSlNlA4SL7O0vJNqGtfz/6bFKX+SyofyvLk1/IGNcxAX8v9JpS8QpDfX/Ha+nwoC8vplIwFYq/TUFbN+w9Zxqr93vpq3fOFWn/BJFlioYQ1UEvgzHxsRQ8Y6NdIgY6jDBI3wugGA53QxVa+IAogeQwR9EB3h27IVGwfqjLc1xWSnZgNZ5bdQYECcGabrcgubMUCPIZjtztQWPsOZpjvPRq52A7KSatKTpV3QfxcXenL61tASUFk8M7q7gIoiywl6UF1fwBKCmLONAVQlhsn8+aYX/8AVEll4pQ8h7x7grLIRj9TgWo0z8Ppsnqv1eqeyP98hX2hZClrrEDH0QpWWuIYJiMbQcx1TNWjYWCQbY8TwQbshJXdWI+obdPdEwbGwJ7ipylQH2vZdN5nK9AMHEVzx1JUeQcF2uVY+rojimJYGY8q7MdEZIy8MGTwfmHuhf5JkTbJex/fyxJdtcpLDzNob5JNrbn/mQMl2ECvNpeKn1sDV6MVjGEz/U9zWSmFYuO82tzr/PzK6fy+UFdP5o6hNP9M742ySyFL1VJrDxSIXu4NJUunvAXPVCApCfufP5p7rg1y2pMZkeswX/u+zIawF0jtwyOmvThiK5UXBhbDgwkIY7mjVKthoBRWymE0MngLbXsrN+bbS5WhQC4sRggVjvtGQ9IWQexGMR7BfjxxBwV6AptRgBIcxU7kwkoODiOCtrhtZOZhkD52m3/KiFGs+VCAdYT3fsicAer5WIcU4DGghPzcta/nfKjhFPa13HrUybW5fBlQQk5hWmXi/fL3rNnuTk5hdX6Pl79/wTwNXrJOYbIXOh9w98atgVqAx7EPx7AUHWDPSGy2la0MOY38zCp0gZWuWNXIbJONAPYhhK0YDSsTocGZbJRmuM9KJ6zAceyHD489zYyxCGMwGYdts24LOLMWi3DHkQ0sg/QqWU5KwvEf4HPMDHseDcc6QTnJUiH7EGajz8g7GPYiH2EWKoOyk/c9vAeax6zzGcryAz5+5PrJ7DIoO37QxTufhRT0C+zLvst11FrC5JQG5f7IrJd5Pjzzx56Pzh4CJc76CnryHugVPMe3OcqfYTkLymkMCpk30RnTlG62jfQLIr5gKkf+wVY29lAWWULTM2HsMah70VSgu888bIULL4hw2pqRPhEmfiMbadmbyWzE/utqSSj2nznBVB7UvWgq0N2lLSIYhxdOWL5k+Xzq/it2mdcGAah7ZV00eQlgxvFRpNfJeyc+Bn2RK32h7sf/AesqcHB02e65AAAAAElFTkSuQmCC';

export const splitGmbAddress = (addressString) =>
  addressString.split(',').map((item) => item.trim());

const extractPlaceDetails = (details = {}) => {
  let streetNumber = '';
  let route = '';
  let city = '';
  let state = '';
  let country = '';
  let zipCode = '';

  details?.address_components?.forEach((entry) => {
    const entryType = entry?.types?.[0];

    if (entryType === 'street_number') {
      streetNumber = entry?.long_name;
    }
    if (entryType === 'route') {
      route = entry?.long_name;
    }
    if (entryType === 'locality') {
      city = entry?.long_name;
    }
    if (entryType === 'administrative_area_level_1') {
      state = entry?.short_name;
    }
    if (entryType === 'country') {
      country = entry?.short_name;
    }
    if (entryType === 'postal_code') {
      zipCode = entry?.long_name;
    }
  });

  return {
    phone: details?.formatted_phone_number,
    reviews: details?.reviews,
    streetNumber,
    route,
    city,
    state,
    country,
    zipCode,
  };
};

export const getGooglePlacesDetails = async (placeId) =>
  new Promise((resolve, reject) => {
    if (!placeId) reject('placeId not provided');
    if (!window?.google?.maps) reject('no google maps');

    try {
      new window.google.maps.places.PlacesService(
        document.getElementById('GooglePlacesServiceMap')
      ).getDetails(
        {
          placeId,
          fields: ['address_components', 'formatted_phone_number', 'reviews'],
        },
        (details) => resolve(extractPlaceDetails(details))
      );
    } catch (e) {
      reject(e);
    }
  });

export const sendDatadogError = (
  error,
  predictionType = 'getPlacePredictions'
) => addErrorToDatadog(`${predictionType} error: ${error}`);

const selectAddressComponents = (selectedGmbAddress, placeDetails) => {
  if (selectedGmbAddress) {
    const [address, city, state, country] = splitGmbAddress(selectedGmbAddress);

    return {
      address: `${placeDetails?.streetNumber} ${address}`.trim(),
      city,
      state: state.toUpperCase(),
      country: formatBusinessCountryCode(country),
      zip: placeDetails?.zipCode,
    };
  }

  return {
    address: `${placeDetails?.streetNumber} ${placeDetails?.route}`.trim(),
    city: placeDetails?.city,
    state: placeDetails?.state,
    country: placeDetails?.country,
    zip: placeDetails?.zipCode,
  };
};

export const selectGmb = async (selectedGmb = {}, setGmb) => {
  const hasSelectedGmb = !!selectedGmb.businessAddress || !!selectedGmb.placeId;
  const gmbToSet = hasSelectedGmb ? selectedGmb : {};
  setGmb && setGmb(gmbToSet);

  if (hasSelectedGmb) {
    try {
      const googlePlaceDetails = await getGooglePlacesDetails(
        selectedGmb?.placeId
      );

      const { address, city, state, country, zip } = selectAddressComponents(
        selectedGmb?.businessAddress,
        googlePlaceDetails
      );

      return {
        address,
        city,
        country,
        gmbAddress: address,
        name: selectedGmb.googleBusinessName,
        phone: googlePlaceDetails?.phone,
        gmbReviews: googlePlaceDetails?.reviews,
        state,
        zip,
      };
    } catch (error) {
      sendDatadogError(error, 'getGmbPlacesDetails');
    }
  } else {
    return {
      name: selectedGmb.googleBusinessName,
    };
  }
};
